import { useEffect } from 'react';
import { pm2SitemapStore, findPageDescriptorByPath } from '@pm2/sitemap-utils';
import { useLocation } from '@provider/navigation';
import { useTrackingManager } from '../_manager.js';

let sentBaseEvents = false;
function useBaseEventsTracking() {
  const tracker = useTrackingManager();
  const location = useLocation();
  const sitemapStore = pm2SitemapStore.useStore();
  useEffect(() => {
    if (sentBaseEvents) {
      return;
    }
    tracker.trackEvent("base.sessionStarted");
    const descriptor = findPageDescriptorByPath(
      sitemapStore.getState(),
      location.asPath
    );
    tracker.trackEvent("userarea.navigation.toContent", {
      method: "deep-link",
      to: location.asPath,
      targetType: (descriptor == null ? void 0 : descriptor.type) ?? "Page"
    });
    sentBaseEvents = true;
  }, []);
}

export { useBaseEventsTracking };
//# sourceMappingURL=hook.base-events.js.map
